// extracted by mini-css-extract-plugin
module.exports = {"label":"b5027","wrapper":"_7c9e4","right-align":"_67fa6","rightAlign":"_67fa6","message":"f45ae","header":"e4db1","text":"ee410","date":"bb1b4"};